module.exports = __webpack_public_path__ + "img/content_2.87f7ebb7.jpg";